import { render, staticRenderFns } from "./UserTabNotifications.vue?vue&type=template&id=3c18ecb2"
import script from "./UserTabNotifications.vue?vue&type=script&lang=js"
export * from "./UserTabNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports